import { useEffect, useState } from 'react'
import { api } from '../services/api'

const DEFAULT_SUPPORT_EMAIL = 'support@medflowllc.com'

// Reads the globally-configured support contact email (set by medflow_admin
// via PATCH /api/admin/support-email). Falls back to the default while
// loading or if the request fails, so callers always have something to show.
export function useSupportEmail(): string {
  const [email, setEmail] = useState(DEFAULT_SUPPORT_EMAIL)
  useEffect(() => {
    let active = true
    api
      .get<{ email: string }>('/support-email')
      .then((res) => {
        if (active && res.data?.email) setEmail(res.data.email)
      })
      .catch(() => {
        /* keep the default */
      })
    return () => {
      active = false
    }
  }, [])
  return email
}
